import { combineReducers } from '@reduxjs/toolkit';

import usAssembly from 'us_pcb_assembly/store/slice';

const rootReducer = combineReducers({
  usAssembly,
});

export default rootReducer;
